import { forwardRef, type Ref, type SVGProps } from "react";
const IconArrowUpOutlineSVG = (
  { children, ...rest }: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    viewBox="0 0 32 32"
    ref={ref}
    {...rest}
  >
    {children}
    <path d="M24.69 14.81a1 1 0 0 1-1.48 0L17 8.5V26a1 1 0 0 1-2 0V8.5l-6.21 6.31a1 1 0 0 1-1.48 0 1.07 1.07 0 0 1 0-1.5l7.89-8A1.1 1.1 0 0 1 16 5a1.13 1.13 0 0 1 .8.31l7.89 8a1.07 1.07 0 0 1 0 1.5" />
  </svg>
);
const ForwardRef = forwardRef(IconArrowUpOutlineSVG);
ForwardRef.displayName = "IconArrowUpOutline";
export { ForwardRef as IconArrowUpOutline };
